import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    callStatisticDetail: state => state.callStatisticDetail,
    callStatisticGroup: state => state.callStatisticGroup,
    callGroupBy: state => state.callGroupings.callGroup,
    callGroupByOptionally: state => state.callGroupings.callGroupOptionally,
};